// extracted by mini-css-extract-plugin
export default {"grid":"ProductList_grid__r2Jl1","grid_indented":"ProductList_grid_indented__gUc9e","grid_column":"ProductList_grid_column__bNH9F"};